module.exports = __webpack_public_path__ + "img/ty.3910f57f.svg";